import { NgModule } from '@angular/core';
import { MenuItemBackgroundColorPipe } from '@shared/pipes/menuItem/menuItemBackgroundColor.pipe';
import { MenuItemChevronPipe } from '@shared/pipes/menuItem/menuItemChevron.pipe';

@NgModule({
  declarations: [MenuItemBackgroundColorPipe, MenuItemChevronPipe],
  exports: [MenuItemBackgroundColorPipe, MenuItemChevronPipe],
})
export class MenuItemPipeModule {}
